/**
 * Helper function to check if a value is empty
 */
export function isEmpty(value) {
    return (
        value === undefined ||
        value === null ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === 'object' && !Array.isArray(value) && value && Object.keys(value).length === 0)
    );
}

/**
 * Helper function to safely handle arrays
 */
export function safeArray(arr) {
    return Array.isArray(arr) ? arr : [];
}

/**
 * Helper function to safely handle objects
 */
export function safeObject(obj) {
    return obj && typeof obj === 'object' && !Array.isArray(obj) ? obj : {};
}

/**
 * Transform treatment plan data for submission
 */
export function transformTreatmentData(dataSource) {
    const transformedData = {};

    safeArray(dataSource).forEach(item => {
        Object.keys(safeObject(item)).forEach(key => {
            if (/^\d{4}-\d{2}-\d{2}$/.test(key)) {
                if (!transformedData[key]) transformedData[key] = [];
                transformedData[key].push({
                    serviceName: item.serviceName,
                    startTime: item.startTime,
                    endTime: item.endTime,
                    totalMinutes: item[key]?.totalMinutes || '0',
                    medicine: item[key]?.medicine || [],
                    medicineValue: item[key]?.medicineValue || item[key]?.medicine?.[0] || null,
                });
            }
        });
    });

    return transformedData;
}

/**
 * Transform medicines data for submission
 */
export function transformMedicinesData(medicines) {
    const medicinesObject = {};

    safeArray(medicines).forEach(medicine => {
        const date = medicine.date;
        if (date) {
            if (!medicinesObject[date]) medicinesObject[date] = [];
            const copy = { ...medicine };
            delete copy.date;
            medicinesObject[date].push(copy);
        }
    });

    return medicinesObject;
}
